/**
 * Confirmation modal shown before logging out.
 */
import { Dialog, DialogTitle, DialogActions, Button } from "@mui/material";
import { useAuth } from "../../../context/AuthContext/AuthContext";
import { useState } from "react";
import { useFirebase } from "../../../context/FirebaseContext/FirebaseContext";

interface logoutModalProps {
  open: boolean;
  onClose: () => void;
}
const LogoutModal: React.FC<logoutModalProps> = ({ open, onClose }) => {
  const { logout } = useAuth();
  const { logoutFirebase } = useFirebase();
  const [waitingResponse, setWaitingResponse] = useState(false);

  const handleLogout = () => {
    setWaitingResponse(true);
    logout(() => {
      window.location.href = "/Login";
    });
    logoutFirebase();
  };
  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>¿Está seguro que desea cerrar sesión?</DialogTitle>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={handleLogout}
            color="error"
            disabled={waitingResponse}
          >
            Cerrar sesión
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default LogoutModal;
